module.exports = __webpack_public_path__ + "img/pexels-chokniti-khongchum.3510a57d.png";